<template>
  <div>
    <v-text-field
      :value="fullText"
      :rules="[$store.state.validationRules.required]"
      label="選擇地區"
      readonly
      @click="showSheet = true"
    />

    <v-bottom-sheet
      v-model="showSheet"
      inset
      max-width="500"
    >
      <v-sheet>
        <v-layout class="pa-2">
          <v-flex class="text-center">
            地址選擇
          </v-flex>
          <v-icon @click="showSheet=false">
            close
          </v-icon>
        </v-layout>
        <v-layout class="blue--text tabs px-2">
          <div
            :class="{'active blue--text': tabActive===0}"
            @click="tabActive=0"
          >
            {{ getAddrText(model.provinceId) || '請選擇' }}
          </div>
          <div
            v-if="model.provinceId"

            :class="{'active blue--text': tabActive===1}"
            @click="tabActive=1"
          >
            {{ getAddrText(model.cityId) || '請選擇' }}
          </div>
          <div
            v-if="model.cityId"
            :class="{'active blue--text': tabActive===2}"
            @click="tabActive=2"
          >
            {{ getAddrText(model.areaId) || '請選擇' }}
          </div>
          <div
            v-if="model.areaId"
            :class="{'active blue--text': tabActive===3}"
            @click="tabActive=3"
          >
            {{ getAddrText(model.townId) || '請選擇' }}
          </div>
        </v-layout>
        <v-divider />
        <div
          class="pa-2"
          style="height: 50vh;overflow-y: auto;"
        >
          <div
            v-if="loading"
            class="text-center py-10"
          >
            <v-progress-circular
              indeterminate
              small
              color="primary"
            />
          </div>
          <div class="px-2">
            <v-layout
              v-for="addrItem in addressItems"
              :key="addrItem.a"
              :class="{'blue--text': addrItem.a === model[currKey]}"
              class="address-item"
              @click="model[currKey] = addrItem.a; nextTab()"
            >
              <span>
                {{ addrItem.n }}
              </span>
              <v-spacer />
              <div v-if="addrItem.a === model[currKey]">
                <v-icon
                  small
                  color="blue"
                >
                  check
                </v-icon>
              </div>
            </v-layout>
          </div>
        </div>

        <div class="pa-4">
          <v-btn
            :disabled="!model.areaId"
            block
            color="info"
            @click="submit"
          >
            確認
          </v-btn>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
import { jsonp } from '@g/utils'

export default {
  props: {

    // provinceText: '',
    // cityText: '',
    // areaText: '',
    // townText: '',
    form: Object,
  },
  data () {
    return {
      addressDataList: [],

      showSheet: false,
      loading: false,
      model: {
        provinceId: '',
        cityId: '',
        areaId: '',
        townId: '',
      },
      tabActive: 0,
    }
  },
  computed: {
    fullText () {
      return (this.form.provinceText + ' ' + this.form.cityText + ' ' + this.form.areaText + ' ' + this.form.townText).trim()
    },
    currKey () {
      if (this.tabActive === 0) {
        return 'provinceId'
      } else if (this.tabActive === 1) {
        return 'cityId'
      } else if (this.tabActive === 2) {
        return 'areaId'
      } else if (this.tabActive === 3) {
        return 'townId'
      }
      return ''
    },
    addressItems () {
      if (this.tabActive === 0) {
        return this.addressDataList.filter(item => !item.p)
      } else if (this.tabActive === 1) {
        return this.addressDataList.filter(item => item.p === this.model.provinceId)
      } else if (this.tabActive === 2) {
        return this.addressDataList.filter(item => item.p === this.model.cityId)
      } else if (this.tabActive === 3) {
        return this.addressDataList.filter(item => item.p === this.model.areaId)
      }

      return []
      // {a: '110100', n: '北京市', l: 3, p: '110000'}
    },
  },
  watch: {
    showSheet () {
      if (this.showSheet) {
        this.init()
      }
    },
    'model.provinceId' () {
      this.model.cityId = ''
    },
    'model.cityId' () {
      this.model.areaId = ''
    },
    'model.areaId' () {
      this.model.townId = ''
      if (this.model.areaId) {
        this.getTownItems()
      }
    },
  },
  methods: {
    getAddrText (id) {
      const item = this.addressDataList.find(item => item.a === id)
      if (item) {
        return item.n
      }
      return ''
    },
    nextTab () {
      if (this.tabActive === 3) {
        return
      }
      this.tabActive++
    },
    async getTownItems () {
      try {
        this.loading = true
        const data = await jsonp(`https://wuliu.1688.com/address/ajax/get_children_address_list.jsx?code=${this.model.areaId}`)
        data.data.forEach(item => {
          if (!this.addressDataList.find(i => i.a === item.a)) {
            this.addressDataList.push(item)
          }
        })
      } finally {
        this.loading = false
      }
    },
    async init () {
      try {
        this.loading = true
        if (!this.addressDataList.length) {
          const a = await import('@g/data/cnAddress.js')
          this.addressDataList = [...a.default]
        }
      } finally {
        this.loading = false
      }
    },
    submit () {
      this.form.provinceText = this.getAddrText(this.model.provinceId)
      this.form.cityText = this.getAddrText(this.model.cityId)
      this.form.areaText = this.getAddrText(this.model.areaId)
      this.form.townText = this.getAddrText(this.model.townId)
      // this.form.cityId = this.model.cityId
      // this.form.areaId = this.model.areaId
      // this.form.townId = this.model.townId
      this.showSheet = false
    }
  },
}
</script>
<style lang="postcss" scoped>
.tabs {
  > * {
    margin-right: 16px;
    padding: 0 4px;
    cursor: pointer;
  }
  .active {
    border-bottom: 1px solid currentColor;
  }
}
.address-item {
  cursor: pointer;
  padding: 8px 8px;
  &:hover {
    background-color: #f5f5f5;
  }
}
</style>
